import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import { Error as ErrorIcon, Star as StarIcon } from '@bibliocommons/base-icons';
import { Link, ChevronLink } from '@bibliocommons/base-links';

import Heading from 'app/components/shared/Heading';
import LocationAlert from 'app/components/locations/LocationAlert';
import LocationAddress from 'app/components/locations/LocationAddress';
import LocationStatus from 'app/components/locations/LocationStatus';

import './LocationItemInfo.scss';

export default function LocationItemInfo({ location, preferred, isInfoWindow }) {
  const hasLocationAlert = Boolean(location.get('hoursNote'));
  const phone = location.get('branchContacts')?.find(contact => contact.get('contactType') === 'phone');

  return (
    <article
      className={cn('cp-location-item-info', {
        'cp-location-item-info--info-window': isInfoWindow
      })}
    >
      <Heading className="heading" tagName="h2" size={isInfoWindow ? 'medium' : 'moderate'}>
        <Link className="heading-name" dataKey="location-heading-link" href={location.get('webUrl')}>
          {location.get('name')}
          {preferred && (
            <span className="preferred-star">
              <StarIcon className="rating-stars__icon--medium" />
            </span>
          )}
        </Link>
        {!isInfoWindow && <LocationAlert location={location} />}
      </Heading>
      <LocationStatus location={location} />
      {isInfoWindow && hasLocationAlert && (
        <p className="alert">
          <ErrorIcon />
          <span>
            <FormattedMessage defaultMessage="Location alert" id="location_alert" />
          </span>
        </p>
      )}
      <LocationAddress location={location} />
      {phone && (
        <div className="contacts">
          <span className="phone-label">
            <FormattedMessage id="phone_label" />
          </span>
          <Link href={`tel:${phone.get('globalValue')}`} dataKey="phone-link">
            {phone.get('value')}
          </Link>
        </div>
      )}
      {isInfoWindow && (
        <ChevronLink className="details-link" dataKey="location-details-link" href={location.get('webUrl')}>
          <FormattedMessage defaultMessage="Location details" id="location_details" />
        </ChevronLink>
      )}
    </article>
  );
}

LocationItemInfo.defaultProps = {
  isInfoWindow: false,
  preferred: false
};

LocationItemInfo.propTypes = {
  location: ImmutablePropTypes.map.isRequired,
  preferred: PropTypes.bool,
  isInfoWindow: PropTypes.bool
};
